import { render } from "./PlayConfigView.vue?vue&type=template&id=cc5f2262&ts=true"
import script from "./PlayConfigView.vue?vue&type=script&lang=ts"
export * from "./PlayConfigView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Admin/Plays/PlayConfigView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cc5f2262"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cc5f2262', __exports__)) {
    api.reload('cc5f2262', __exports__)
  }
  
  module.hot.accept("./PlayConfigView.vue?vue&type=template&id=cc5f2262&ts=true", () => {
    api.rerender('cc5f2262', render)
  })

}


export default __exports__